import { QueryClient, useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createContent } from "../../../api/manual-import";
import { V3GenericErrorHandler } from "../../../api/error-handler";
import LocalStore, { LocalStorageKeys } from "../../../localstorage/LocalStorage";
import { getItemQuerie } from "../../../types/queries";

// Create content mutation
export const getCreateContentMutation = (queryClient: QueryClient, token: string) =>
    useMutation({
        mutationFn: createContent,
        onError: V3GenericErrorHandler(toast.error),
        onSuccess: async (data) => {
            new LocalStore(LocalStorageKeys.editor_article_html).unset();
            new LocalStore(LocalStorageKeys.editor_article_title).unset();

            const shares = {
                facebook: null,
                linkedin: null,
                twitter: null,
                pinterest: null,
                sum: 0
            };

            const itemQuerie = getItemQuerie(token, data.canonicalSlug);

            // Update item data
            queryClient.setQueryData(itemQuerie, {
                article: data,
                shares
            });

            queryClient.invalidateQueries({ queryKey: itemQuerie });
        }
    });
